import { useMemo } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { teamReportFeatures, type ReportFeature } from '@/reports/catalog';

/** The report features the active team has on (from the session's team settings). */
export function useReportFeatures(): ReadonlySet<ReportFeature> {
  const settings = useAuthStore((s) => s.user?.active_team?.settings);
  return useMemo(() => teamReportFeatures(settings), [settings]);
}
